import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { USER_ROLE } from '@rms/user';

import { AuthService } from '../services';

// Reads roles from the token: guards run before currentUserResolver fills UserStoreService
export const roleGuard =
  (...roles: USER_ROLE[]): CanActivateFn =>
  () => {
    const user = inject(AuthService).getCurrentUser();

    return user?.roles.some((role) => roles.includes(role)) || inject(Router).createUrlTree(['/']);
  };
